import { nullsToUndefined } from "../../../../null.js";
const parseNumber = (num)=>Number(num) || 0;
const blogItem = (item)=>{
    const { title ='' , image ={
        src: ''
    } , link ={
        href: ''
    } , date ={} , featured =false  } = item;
    return {
        title,
        featured,
        image,
        link: nullsToUndefined(link),
        date: {
            day: parseNumber(date.day),
            month: date.month ?? '',
            year: parseNumber(date.year)
        },
        description: '',
        share: []
    };
};
export const blogMarketingMobileConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { title ='' , link ={
        href: ''
    } , literals , items =[]  } = data;
    return {
        name: 'm-blog',
        props: {
            config: {
                literals: {
                    ...literals,
                    published: literals?.published,
                    viewMore: literals?.viewMore ?? nullsToUndefined(link).content
                }
            },
            title,
            items: items.map(blogItem),
            link: nullsToUndefined(link)
        }
    };
};

//# sourceMappingURL=converter.js.map